import { HIDE_NOTIFICATION, SHOW_NOTIFICATION } from "./actionTypes";

export const initialNotificationStoreState = {
  open: false,
  type: "",
  title: "",
  subtitle: "",
  primaryAction: null,
};

export default function notificationStoreReducer(
  state = initialNotificationStoreState,
  action
) {
  switch (action.type) {
    case SHOW_NOTIFICATION:
      return {
        ...state,
        open: true,
        type: action.payload.type,
        title: action.payload.title,
        subtitle: action.payload.subtitle,
        primaryAction: action.payload.primaryAction,
      };
    case HIDE_NOTIFICATION:
      return { ...state, open: false };
    default:
      return state;
  }
}
